import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { get, isEmpty } from 'lodash/fp';
import addModifiers from 'utils/add_modifiers';
import DateFormat from 'constants/date_format.js';
import AlertBox, { Heading, SubHeading } from 'components/shared/AlertBox';

const ConfirmationModal = ({
  onDismiss,
  onSubmit,
  updatedAt,
  createdAt,
  isCertification,
  features,
}) => {
  const { user, date } = isEmpty(updatedAt) ? createdAt : updatedAt;
  const formattedDate = moment(date).format(DateFormat.LONG_AT_TIME);

  return (
    <AlertBox onDismiss={onDismiss}>
      <Heading>Discard Changes?</Heading>
      <SubHeading>
        This {isCertification ? 'Certification Path' : 'Path'} was last saved{' '}
        {formattedDate} by {user}.
      </SubHeading>
      <div className="d-f jc-e ai-c mt-24">
        <button
          type="button"
          className="u-linkBtn u-linkBtn--dark td-u"
          onClick={onDismiss}
          children="No, Keep Changes"
        />
        <button
          type="button"
          className={`ml-16 ${addModifiers('NewButton', [
            'yellow',
            'tallAndWide',
          ])}`}
          onClick={onSubmit}
          children="Yes, Discard Changes"
        />
      </div>
    </AlertBox>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  updatedAt: pathBuilder.updatedAt,
  createdAt: pathBuilder.createdAt,
  isCertification: !!get('certification')(pathBuilder),
});

export default connect(mapStateToProps)(ConfirmationModal);
